module.exports = __webpack_public_path__ + "img/72000.8b8072d5.jpg";